// extracted by mini-css-extract-plugin
export default {"container":"Header_container__LfHsy","search":"Header_search__OzAkB","dropdowns":"Header_dropdowns__ZlMbm"};